import { render, staticRenderFns } from "./QuizManagement.vue?vue&type=template&id=0ecf72bc&scoped=true"
import script from "./QuizManagement.vue?vue&type=script&lang=js"
export * from "./QuizManagement.vue?vue&type=script&lang=js"
import style0 from "./QuizManagement.vue?vue&type=style&index=0&id=0ecf72bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf72bc",
  null
  
)

export default component.exports